import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Box, TextField, Typography } from '@mui/material'
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked'
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked'

function DeliveryDateTimePicker({
  deliveryDate,
  deliveryTimeStart,
  deliveryTimeEnd,
  timeFilterType,
  onDeliveryDateChange,
  onDeliveryTimeStartChange,
  onDeliveryTimeEndChange,
  onTimeFilterTypeChange,
  isNotModifiable,
  hideTitle,
  disableMargin,
}) {
  const { t } = useTranslation('order_detail')

  return (
    <Box mb={disableMargin ? 0 : 2}>
      {!hideTitle && <Typography variant="h6" gutterBottom>{t('deliveryDateTime')}</Typography>}
      <Box display="flex" alignItems="center" gap={1} mb={1}>
        <Box
          display="flex" alignItems="center" gap={0.5}
          sx={{ cursor: 'pointer' }}
          onClick={() => onTimeFilterTypeChange('exact')}
        >
          {timeFilterType === 'exact' ? (
            <RadioButtonCheckedIcon sx={{ color: '#1577FC', fontSize: 18, pointerEvents: 'none', position: 'static' }} />
          ) : (
            <RadioButtonUncheckedIcon sx={{ color: '#737373', fontSize: 18, pointerEvents: 'none', position: 'static' }} />
          )}
          <Typography variant="body2">{t('exactTime')}</Typography>
        </Box>
        <Box
          display="flex" alignItems="center" gap={0.5}
          sx={{ cursor: 'pointer' }}
          onClick={() => onTimeFilterTypeChange('range')}
        >
          {timeFilterType === 'range' ? (
            <RadioButtonCheckedIcon sx={{ color: '#1577FC', fontSize: 18, pointerEvents: 'none', position: 'static' }} />
          ) : (
            <RadioButtonUncheckedIcon sx={{ color: '#737373', fontSize: 18, pointerEvents: 'none', position: 'static' }} />
          )}
          <Typography variant="body2">{t('timeRange')}</Typography>
        </Box>
      </Box>
      <Box display="flex" alignItems="center" gap={1}>
        <Typography variant="body2" sx={{ fontWeight: 500, whiteSpace: 'nowrap' }}>{t('start')}</Typography>
        <TextField
          type="date"
          size="small"
          value={deliveryDate || ''}
          onChange={(e) => onDeliveryDateChange(e.target.value)}
          InputLabelProps={{ shrink: true }}
          disabled={isNotModifiable}
          sx={{ width: '160px' }}
        />
        <TextField
          type="time"
          size="small"
          value={deliveryTimeStart || ''}
          onChange={(e) => onDeliveryTimeStartChange(e.target.value)}
          InputLabelProps={{ shrink: true }}
          disabled={isNotModifiable}
          sx={{
            width: '100px',
            "& .MuiInputBase-root": { width: '95px' },
          }}
        />
        {timeFilterType === 'range' && (
          <>
            <Typography variant="body2" sx={{ whiteSpace: 'nowrap' }}>: {t('end')}</Typography>
            <TextField
              type="time"
              size="small"
              value={deliveryTimeEnd || ''}
              onChange={(e) => onDeliveryTimeEndChange(e.target.value)}
              InputLabelProps={{ shrink: true }}
              disabled={isNotModifiable}
              sx={{
                width: '100px',
                "& .MuiInputBase-root": { width: '95px' },
              }}
            />
          </>
        )}
      </Box>
    </Box>
  )
}

DeliveryDateTimePicker.propTypes = {
  deliveryDate: PropTypes.string,
  deliveryTimeStart: PropTypes.string,
  deliveryTimeEnd: PropTypes.string,
  timeFilterType: PropTypes.oneOf(['exact', 'range']).isRequired,
  onDeliveryDateChange: PropTypes.func.isRequired,
  onDeliveryTimeStartChange: PropTypes.func.isRequired,
  onDeliveryTimeEndChange: PropTypes.func.isRequired,
  onTimeFilterTypeChange: PropTypes.func.isRequired,
  isNotModifiable: PropTypes.bool.isRequired,
  hideTitle: PropTypes.bool,
  disableMargin: PropTypes.bool,
}

export default DeliveryDateTimePicker
